import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './style.css'; // Import the main stylesheet (assuming it's moved to src/style.css)
import './App.css'; // App.css can provide overrides or component-specific styles

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 